let endTimeString = '2019-06-12 12:00'
let endTime = new Date(endTimeString).getTime()
let nowTime = new Date().getTime()

let isEnd = nowTime > endTime
export default {
  endTimeString,
  isEnd
}



// WEBPACK FOOTER //
// ./src/utils/signUpEndTime.js